/* ---------- page background: full-bleed bayer-dithered ink wave (WebGL2) ---------- */
(function(){
  var c=document.getElementById('grain'); if(!c) return;
  var gl=c.getContext('webgl2',{alpha:false,antialias:false}); if(!gl) return;
  var V='#version 300 es\nin vec2 position;void main(){gl_Position=vec4(position,0.,1.);}';
  var F='#version 300 es\nprecision highp float;uniform vec2 R;uniform float T;out vec4 o;\
const float BAYER[64]=float[64](0.,48.,12.,60.,3.,51.,15.,63.,32.,16.,44.,28.,35.,19.,47.,31.,8.,56.,4.,52.,11.,59.,7.,55.,40.,24.,36.,20.,43.,27.,39.,23.,2.,50.,14.,62.,1.,49.,13.,61.,34.,18.,46.,30.,33.,17.,45.,29.,10.,58.,6.,54.,9.,57.,5.,53.,42.,26.,38.,22.,41.,25.,37.,21.);\
vec4 mod289(vec4 x){return x-floor(x*(1./289.))*289.;}\
vec4 permute(vec4 x){return mod289(((x*34.)+1.)*x);}\
vec2 fade(vec2 t){return t*t*t*(t*(t*6.-15.)+10.);}\
float cnoise(vec2 P){vec4 Pi=floor(P.xyxy)+vec4(0.,0.,1.,1.);vec4 Pf=fract(P.xyxy)-vec4(0.,0.,1.,1.);Pi=mod289(Pi);\
vec4 ix=Pi.xzxz,iy=Pi.yyww,fx=Pf.xzxz,fy=Pf.yyww;vec4 i=permute(permute(ix)+iy);\
vec4 gx=fract(i*(1./41.))*2.-1.;vec4 gy=abs(gx)-.5;vec4 tx=floor(gx+.5);gx=gx-tx;\
vec2 g00=vec2(gx.x,gy.x),g10=vec2(gx.y,gy.y),g01=vec2(gx.z,gy.z),g11=vec2(gx.w,gy.w);\
vec4 norm=1.79284291400159-0.85373472095314*vec4(dot(g00,g00),dot(g01,g01),dot(g10,g10),dot(g11,g11));\
g00*=norm.x;g01*=norm.y;g10*=norm.z;g11*=norm.w;\
float n00=dot(g00,vec2(fx.x,fy.x)),n10=dot(g10,vec2(fx.y,fy.y)),n01=dot(g01,vec2(fx.z,fy.z)),n11=dot(g11,vec2(fx.w,fy.w));\
vec2 fxy=fade(Pf.xy);vec2 nx=mix(vec2(n00,n01),vec2(n10,n11),fxy.x);return 2.3*mix(nx.x,nx.y,fxy.y);}\
float fbm(vec2 p){float v=0.,a=1.,f=2.4;for(int i=0;i<4;i++){v+=a*abs(cnoise(p));p*=f;a*=.32;}return v;}\
void main(){vec2 uv=gl_FragCoord.xy/R.xy;uv-=.5;uv.x*=R.x/R.y;\
float f=clamp(fbm(uv*1.15+fbm(uv-T*.02)),0.,1.);\
float v=mix(0.,.2,f);\
int x=int(mod(gl_FragCoord.x,8.));int y=int(mod(gl_FragCoord.y,8.));\
float th=BAYER[y*8+x]/64.-.25;v+=th*(1./3.);v=clamp(v-.14,0.,1.);\
v=floor(v*3.+.5)/3.;vec3 col=vec3(.045,.044,.042)+v*vec3(.35,.343,.32);o=vec4(col,1.);}';
  function sh(t,x){var q=gl.createShader(t);gl.shaderSource(q,x);gl.compileShader(q);return q;}
  var p=gl.createProgram();gl.attachShader(p,sh(gl.VERTEX_SHADER,V));gl.attachShader(p,sh(gl.FRAGMENT_SHADER,F));
  gl.bindAttribLocation(p,0,'position');gl.linkProgram(p);
  if(!gl.getProgramParameter(p,gl.LINK_STATUS)) return;
  gl.useProgram(p);
  var b=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,b);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,3,-1,-1,3]),gl.STATIC_DRAW);
  gl.enableVertexAttribArray(0);gl.vertexAttribPointer(0,2,gl.FLOAT,false,0,0);
  var uR=gl.getUniformLocation(p,'R'),uT=gl.getUniformLocation(p,'T');
  var dprD=Math.min(devicePixelRatio||1,3);
  var PIX=Math.max(2,Math.min(4,6/dprD));          // ~6 physical px per dither cell on every screen
  function rs(){var r=c.getBoundingClientRect();var w=Math.max(1,r.width/PIX|0),h=Math.max(1,r.height/PIX|0);
    if(c.width!==w||c.height!==h){c.width=w;c.height=h;}gl.viewport(0,0,w,h);gl.uniform2f(uR,w,h);}
  new ResizeObserver(rs).observe(c);rs();
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches,raf=0,vis=true,t0=performance.now();
  function draw(t){gl.uniform1f(uT,(t-t0)*.001);gl.drawArrays(gl.TRIANGLES,0,3);}
  function loop(t){draw(t);raf=requestAnimationFrame(loop);}
  function go(){if(reduce)return;if(vis&&!raf)raf=requestAnimationFrame(loop);}
  function stop(){if(raf){cancelAnimationFrame(raf);raf=0;}}
  new IntersectionObserver(function(e){vis=e[0].isIntersecting;vis?go():stop();},{threshold:0}).observe(c);
  document.addEventListener('visibilitychange',function(){vis=!document.hidden;vis?go():stop();});
  draw(t0);go();
})();

/* ---------- coin tilt ---------- */
(function(){
  var coin=document.querySelector('.coin'),tilt=document.querySelector('.coin__tilt');if(!tilt)return;
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;if(reduce)return;
  var px=0,py=0;
  addEventListener('pointermove',function(e){var r=coin.getBoundingClientRect();px=Math.max(-1,Math.min(1,(e.clientX-(r.left+r.width/2))/r.width));py=Math.max(-1,Math.min(1,(e.clientY-(r.top+r.height/2))/r.height));},{passive:true});
  function frame(t){var r=coin.getBoundingClientRect(),prog=((r.top+r.height/2)-innerHeight/2)/innerHeight;
    var fy=Math.sin(t/1600)*4,rx=(-prog*10)+(-py*8),ry=(px*14)+(t/60%360*0);
    tilt.style.transform='translateY('+fy.toFixed(2)+'px) rotateX('+rx.toFixed(2)+'deg) rotateY('+ry.toFixed(2)+'deg)';
    requestAnimationFrame(frame);}
  requestAnimationFrame(frame);
})();

/* ---------- chapter orchestration + reveal + dots ---------- */
(function(){
  var exp=document.getElementById('exp'),chapters=exp.querySelectorAll('.chapter'),dots=[].slice.call(document.querySelectorAll('#dots li'));
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setActive(i){exp.setAttribute('data-ch',i);dots.forEach(function(d,k){d.classList.toggle('on',k===i);});}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var sec=e.target.closest('.chapter');setActive(+sec.getAttribute('data-ch'));}});},{threshold:.5});
  var rio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.closest('.chapter').classList.add('seen');rio.unobserve(e.target);}});},{threshold:.12});
  chapters.forEach(function(c){var t=c.classList.contains('chapter--pin')?c.querySelector('.pin'):c;io.observe(t);rio.observe(t);});
  // reveal closing sections too
  if(!reduce){var cio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('seen');cio.unobserve(e.target);}});},{threshold:.15});
    document.querySelectorAll('.close .sec').forEach(function(s){s.classList.add('rv');s.setAttribute('data-from','up');cio.observe(s);});}
  else{document.querySelectorAll('.rv').forEach(function(el){el.style.opacity=1;el.style.transform='none';});exp.setAttribute('data-ch','0');}
  dots.forEach(function(d){d.addEventListener('click',function(){var i=+d.getAttribute('data-go');(chapters[i]||{}).scrollIntoView&&chapters[i].scrollIntoView({behavior:'smooth'});});});
})();
/* (scroll-scrubbed parallax removed: heading chapters no longer pan/fade with scroll -
   content is simply present; per-chapter background/coin choreography stays below) */

/* ---------- we design with you: self-playing chat, two cycling screens ---------- */
(function(){
  var ch=document.querySelector('.chapter--chat');if(!ch)return;
  var chat=document.getElementById('jc-chat');if(!chat)return;
  var scr=[].slice.call(chat.querySelectorAll('.chat__scr'));
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var timers=[], inView=false, running=false;
  function T(fn,ms){ var id=setTimeout(fn,ms); timers.push(id); return id; }
  function clearAll(){ timers.forEach(clearTimeout); timers=[]; }
  function mark(step){ var el=chat.querySelector('[data-step="'+step+'"]'); if(el) el.classList.add('in'); }
  function pollVotes(step){ var el=chat.querySelector('[data-step="'+step+'"]'); return el?[].slice.call(el.querySelectorAll('.cvote')):[]; }
  function winner(votes){ var max=-1,mi=0; votes.forEach(function(v,j){ var n=parseInt((v.querySelector('b')||{}).textContent||'0',10); if(n>max){max=n;mi=j;} }); return mi; }
  function cycle(step,at){ var votes=pollVotes(step); if(!votes.length) return at;
    votes.forEach(function(v,idx){ T(function(){ votes.forEach(function(x,j){ x.classList.toggle('sel', j===idx); }); }, at+idx*400); });
    T(function(){ var mi=winner(votes); votes.forEach(function(x,j){ x.classList.toggle('sel', j===mi); }); }, at+votes.length*400);
    return at+votes.length*400+450;
  }
  function setScr(k){ scr.forEach(function(s,j){ s.classList.toggle('on',j===k); }); }
  function clearSteps(root){ [].slice.call(root.querySelectorAll('[data-step]')).forEach(function(m){m.classList.remove('in');}); [].slice.call(root.querySelectorAll('.cvote')).forEach(function(v){v.classList.remove('sel');}); }
  function showAll(){ setScr(0); if(scr[0]){ [].slice.call(scr[0].querySelectorAll('[data-step]')).forEach(function(m){m.classList.add('in');}); }
    var v=pollVotes(2); if(v.length){ var mi=winner(v); v.forEach(function(x,j){x.classList.toggle('sel',j===mi);}); } }
  function reset(){ clearAll(); clearSteps(chat); setScr(0); }
  function play(){
    if(!inView||!running) return;
    reset();
    var t=400;
    T(function(){ mark(1); }, t); t+=950;
    (function(at){ T(function(){ mark(2); }, at); })(t); t=cycle(2,t+300)+250;
    (function(at){ T(function(){ mark(3); }, at); })(t); t+=650;
    (function(at){ T(function(){ mark(4); }, at); })(t); t+=1050;
    (function(at){ T(function(){ mark(5); }, at); })(t); t+=1650;                       // hold finished screen A
    (function(at){ T(function(){ setScr(1); clearSteps(scr[0]); }, at); })(t); t+=600;  // crossfade to screen B
    (function(at){ T(function(){ mark(6); }, at); })(t); t+=800;
    (function(at){ T(function(){ mark(7); }, at); })(t); t=cycle(7,t+300)+250;
    (function(at){ T(function(){ mark(8); }, at); })(t); t+=800;
    (function(at){ T(function(){ mark(9); }, at); })(t); t=cycle(9,t+300)+450;
    T(function(){ play(); }, t+2100);
  }
  function start(){ if(running)return; running=true; if(reduce){ showAll(); return; } play(); }
  function stop(){ running=false; clearAll(); }
  if(reduce){ showAll(); return; }
  new IntersectionObserver(function(e){ inView=e[0].isIntersecting; if(inView) start(); else stop(); },{threshold:.3}).observe(ch);
})();

/* ---------- design flow: steps light up as they cross a scroll line ---------- */
(function(){
  var ch=document.querySelector('.chapter--tl');if(!ch)return;
  var steps=[].slice.call(ch.querySelectorAll('.tl__p'));if(!steps.length)return;
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce){ steps.forEach(function(s){s.classList.add('lit');}); return; }
  var inView=true, raf=0;
  function apply(){ var line=innerHeight*0.78; for(var i=0;i<steps.length;i++){ if(!steps[i].classList.contains('lit') && steps[i].getBoundingClientRect().top < line){ steps[i].classList.add('lit'); } } }
  function loop(){ if(!inView){ raf=0; return; } apply(); raf=requestAnimationFrame(loop); }
  new IntersectionObserver(function(e){ inView=e[0].isIntersecting; if(inView&&!raf){ raf=requestAnimationFrame(loop); } },{threshold:0}).observe(ch);
  apply(); raf=requestAnimationFrame(loop);
})();

/* ---------- panel dither: bayer-dithered noise wave (WebGL2) on each .jx-dither ---------- */
(function(){
  function initDither(c){
  var gl=c.getContext('webgl2',{alpha:false,antialias:false}); if(!gl){ c.style.display='none'; return; }
  var V='#version 300 es\nin vec2 position;void main(){gl_Position=vec4(position,0.,1.);}';
  var F='#version 300 es\nprecision highp float;uniform vec2 R;uniform float T;out vec4 o;\
const float BAYER[64]=float[64](0.,48.,12.,60.,3.,51.,15.,63.,32.,16.,44.,28.,35.,19.,47.,31.,8.,56.,4.,52.,11.,59.,7.,55.,40.,24.,36.,20.,43.,27.,39.,23.,2.,50.,14.,62.,1.,49.,13.,61.,34.,18.,46.,30.,33.,17.,45.,29.,10.,58.,6.,54.,9.,57.,5.,53.,42.,26.,38.,22.,41.,25.,37.,21.);\
vec4 mod289(vec4 x){return x-floor(x*(1./289.))*289.;}\
vec4 permute(vec4 x){return mod289(((x*34.)+1.)*x);}\
vec2 fade(vec2 t){return t*t*t*(t*(t*6.-15.)+10.);}\
float cnoise(vec2 P){vec4 Pi=floor(P.xyxy)+vec4(0.,0.,1.,1.);vec4 Pf=fract(P.xyxy)-vec4(0.,0.,1.,1.);Pi=mod289(Pi);\
vec4 ix=Pi.xzxz,iy=Pi.yyww,fx=Pf.xzxz,fy=Pf.yyww;vec4 i=permute(permute(ix)+iy);\
vec4 gx=fract(i*(1./41.))*2.-1.;vec4 gy=abs(gx)-.5;vec4 tx=floor(gx+.5);gx=gx-tx;\
vec2 g00=vec2(gx.x,gy.x),g10=vec2(gx.y,gy.y),g01=vec2(gx.z,gy.z),g11=vec2(gx.w,gy.w);\
vec4 norm=1.79284291400159-0.85373472095314*vec4(dot(g00,g00),dot(g01,g01),dot(g10,g10),dot(g11,g11));\
g00*=norm.x;g01*=norm.y;g10*=norm.z;g11*=norm.w;\
float n00=dot(g00,vec2(fx.x,fy.x)),n10=dot(g10,vec2(fx.y,fy.y)),n01=dot(g01,vec2(fx.z,fy.z)),n11=dot(g11,vec2(fx.w,fy.w));\
vec2 fxy=fade(Pf.xy);vec2 nx=mix(vec2(n00,n01),vec2(n10,n11),fxy.x);return 2.3*mix(nx.x,nx.y,fxy.y);}\
float fbm(vec2 p){float v=0.,a=1.,f=2.4;for(int i=0;i<4;i++){v+=a*abs(cnoise(p));p*=f;a*=.32;}return v;}\
void main(){vec2 uv=gl_FragCoord.xy/R.xy;uv-=.5;uv.x*=R.x/R.y;\
float f=clamp(fbm(uv+fbm(uv-T*.03)),0.,1.);\
float v=mix(0.,.32,f);\
int x=int(mod(gl_FragCoord.x,8.));int y=int(mod(gl_FragCoord.y,8.));\
float th=BAYER[y*8+x]/64.-.25;v+=th*(1./3.);v=clamp(v-.18,0.,1.);\
v=floor(v*3.+.5)/3.;vec3 col=v*vec3(.95,.93,.87);o=vec4(col,1.);}';
  function sh(t,s){var x=gl.createShader(t);gl.shaderSource(x,s);gl.compileShader(x);return x;}
  var p=gl.createProgram();gl.attachShader(p,sh(gl.VERTEX_SHADER,V));gl.attachShader(p,sh(gl.FRAGMENT_SHADER,F));
  gl.bindAttribLocation(p,0,'position');gl.linkProgram(p);
  if(!gl.getProgramParameter(p,gl.LINK_STATUS)){ c.style.display='none'; return; }
  gl.useProgram(p);
  var b=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,b);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,3,-1,-1,3]),gl.STATIC_DRAW);
  gl.enableVertexAttribArray(0);gl.vertexAttribPointer(0,2,gl.FLOAT,false,0,0);
  var uR=gl.getUniformLocation(p,'R'),uT=gl.getUniformLocation(p,'T');
  var PIX=Math.max(2,Math.min(4,6/Math.min(devicePixelRatio||1,3)));   // ~6 physical px cells on every screen
  function rs(){var r=c.getBoundingClientRect();var w=Math.max(1,r.width/PIX|0),h=Math.max(1,r.height/PIX|0);
    if(c.width!==w||c.height!==h){c.width=w;c.height=h;}gl.viewport(0,0,w,h);gl.uniform2f(uR,w,h);}
  new ResizeObserver(rs).observe(c);rs();
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches,raf=0,vis=true,t0=performance.now();
  function draw(t){gl.uniform1f(uT,(t-t0)*.001);gl.drawArrays(gl.TRIANGLES,0,3);}
  function loop(t){draw(t);raf=requestAnimationFrame(loop);}
  function go(){if(reduce)return;if(vis&&!raf)raf=requestAnimationFrame(loop);}
  function stop(){if(raf){cancelAnimationFrame(raf);raf=0;}}
  new IntersectionObserver(function(e){vis=e[0].isIntersecting;vis?go():stop();},{threshold:0}).observe(c);
  document.addEventListener('visibilitychange',function(){vis=vis&&!document.hidden;document.hidden?stop():go();});
  draw(t0);go();
  }
  [].slice.call(document.querySelectorAll('canvas.jx-dither')).forEach(initDither);
})();

/* ---------- ink boil: cycle turbulence seeds (hand-drawn "boiling line") ---------- */
(function(){
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches; if(reduce) return;
  var nodes=[].slice.call(document.querySelectorAll('.jx-boil')); if(!nodes.length) return;
  var exp=document.getElementById('exp'), inView=true, seed=1, id=0;
  function tick(){ seed=(seed%6)+1; for(var i=0;i<nodes.length;i++) nodes[i].setAttribute('seed',String(seed)); }
  function start(){ if(!id) id=setInterval(tick,360); }
  function stop(){ if(id){ clearInterval(id); id=0; } }
  if(exp&&'IntersectionObserver' in window){ new IntersectionObserver(function(e){ inView=e[0].isIntersecting; inView?start():stop(); },{threshold:0}).observe(exp); }
  document.addEventListener('visibilitychange',function(){ document.hidden?stop():(inView&&start()); });
  start();
})();

/* ---------- ink text: replace marked headings with solid boiling ink (svg text) ---------- */
(function(){
  var els=[].slice.call(document.querySelectorAll('[data-jxink]')); if(!els.length) return;
  var NS='http://www.w3.org/2000/svg';
  function build(el){
    if(el.classList.contains('ink-on')||el.querySelector('.ink-svg')) return;   // idempotent
    var lines=[[]];
    [].slice.call(el.childNodes).forEach(function(n){ if(n.nodeName==='BR'){lines.push([]);} else lines[lines.length-1].push(n.textContent||''); });
    lines=lines.map(function(a){return a.join('').replace(/\s+/g,' ').trim();}).filter(Boolean);
    if(!lines.length) return;
    var centered=getComputedStyle(el).textAlign==='center';
    var svg=document.createElementNS(NS,'svg'); svg.setAttribute('class','ink-svg'); svg.setAttribute('aria-hidden','true'); svg.setAttribute('focusable','false');
    if(centered) svg.style.margin='0 auto';
    var texts=lines.map(function(ln,i){ var t=document.createElementNS(NS,'text');
      t.setAttribute('x','0'); t.setAttribute('y',String(i*102+82)); t.setAttribute('filter','url(#jx-ink2)');
      t.textContent=ln; svg.appendChild(t); return t; });
    var keep=document.createElement('span'); keep.className='ink-orig';
    while(el.firstChild) keep.appendChild(el.firstChild);
    el.appendChild(keep); el.appendChild(svg); el.classList.add('ink-on');
    function size(){
      var w=0; texts.forEach(function(t){ try{ w=Math.max(w,t.getComputedTextLength()); }catch(e){} });
      if(!w||!isFinite(w)){ el.classList.remove('ink-on'); svg.style.display='none'; return; }
      el.classList.add('ink-on'); svg.style.display='';
      if(centered){ texts.forEach(function(t){ t.setAttribute('x',String(w/2)); t.setAttribute('text-anchor','middle'); }); }
      var H=lines.length*102+12, pad=16;
      svg.setAttribute('viewBox',(-pad)+' 0 '+(w+pad*2)+' '+H);
      var fs=parseFloat(getComputedStyle(el).fontSize)||40, k=fs/100;
      svg.style.width=((w+pad*2)*k)+'px'; svg.style.height=(H*k)+'px';
    }
    size(); addEventListener('resize',size,{passive:true});
    if(document.fonts&&document.fonts.ready) document.fonts.ready.then(size);
  }
  function all(){ els.forEach(build); }
  if(document.fonts&&document.fonts.ready){ document.fonts.ready.then(all); } else { all(); }
})();

/* ---------- free shipping: rotating dotted globe (canvas port of the Globe ref) ---------- */
(function(){
  var cv=document.getElementById('jc-globe'); if(!cv||!cv.getContext) return;
  var ctx=cv.getContext('2d'); if(!ctx) return;
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LAND='-54,-70;-50,-73;-47,-75;-47,-69;-47,168;-43,-71;-43,-66;-43,146;-43,172;-39,-72;-39,-68;-39,-63;-39,177;-35,-68;-35,-64;-35,-59;-35,141;-35,146;-35,150;-35,173;-31,-69;-31,-64;-31,-60;-31,-55;-31,20;-31,25;-31,29;-31,118;-31,123;-31,127;-31,132;-31,136;-31,141;-31,145;-31,149;-28,-69;-28,-64;-28,-60;-28,-56;-28,-51;-28,17;-28,22;-28,26;-28,30;-28,116;-28,120;-28,124;-28,129;-28,133;-28,137;-28,142;-28,146;-28,150;-24,-68;-24,-64;-24,-60;-24,-55;-24,-51;-24,-47;-24,15;-24,19;-24,24;-24,28;-24,32;-24,44;-24,115;-24,119;-24,123;-24,127;-24,131;-24,136;-24,140;-24,144;-24,148;-20,-67;-20,-63;-20,-59;-20,-55;-20,-51;-20,-47;-20,-43;-20,14;-20,18;-20,22;-20,26;-20,30;-20,34;-20,46;-20,119;-20,123;-20,127;-20,131;-20,135;-20,139;-20,144;-20,148;-16,-180;-16,-73;-16,-69;-16,-65;-16,-61;-16,-57;-16,-53;-16,-49;-16,-45;-16,-42;-16,14;-16,18;-16,22;-16,26;-16,30;-16,34;-16,38;-16,46;-16,50;-16,125;-16,129;-16,133;-16,137;-16,144;-12,-75;-12,-71;-12,-67;-12,-63;-12,-59;-12,-55;-12,-52;-12,-48;-12,-44;-12,-40;-12,15;-12,18;-12,22;-12,26;-12,30;-12,34;-12,38;-12,131;-12,135;-12,143;-9,-76;-9,-72;-9,-69;-9,-65;-9,-61;-9,-57;-9,-53;-9,-49;-9,-45;-9,-42;-9,-38;-9,16;-9,20;-9,24;-9,28;-9,31;-9,35;-9,39;-9,143;-9,147;-5,-81;-5,-77;-5,-73;-5,-69;-5,-66;-5,-62;-5,-58;-5,-54;-5,-50;-5,-47;-5,-43;-5,-39;-5,14;-5,18;-5,22;-5,26;-5,30;-5,34;-5,37;-5,140;-5,144;-5,152;-1,-77;-1,-74;-1,-70;-1,-66;-1,-62;-1,-58;-1,-55;-1,-51;-1,-47;-1,10;-1,14;-1,18;-1,21;-1,25;-1,29;-1,33;-1,37;-1,40;-1,101;-1,113;-1,116;-1,120;-1,132;3,-77;3,-73;3,-70;3,-66;3,-62;3,-58;3,-54;3,10;3,14;3,18;3,22;3,25;3,29;3,33;3,37;3,41;3,44;3,98;3,102;3,113;3,117;7,-77;7,-73;7,-69;7,-65;7,-61;7,-8;7,-4;7,0;7,4;7,7;7,11;7,15;7,19;7,23;7,27;7,30;7,34;7,38;7,42;7,46;7,80;10,-83;10,-72;10,-68;10,-64;10,-14;10,-10;10,-6;10,-2;10,2;10,5;10,9;10,13;10,17;10,21;10,25;10,29;10,32;10,36;10,40;10,44;10,48;10,79;10,106;10,125;14,-90;14,-86;14,-15;14,-11;14,-8;14,-4;14,0;14,4;14,8;14,12;14,16;14,20;14,24;14,28;14,32;14,36;14,40;14,43;14,47;14,75;14,79;14,98;14,102;14,106;14,122;18,-100;18,-96;18,-92;18,-12;18,-8;18,-4;18,0;18,4;18,8;18,12;18,16;18,20;18,24;18,28;18,32;18,36;18,44;18,48;18,52;18,56;18,76;18,80;18,96;18,100;18,104;22,-102;22,-98;22,-78;22,-16;22,-12;22,-8;22,-4;22,0;22,4;22,8;22,12;22,16;22,21;22,25;22,29;22,33;22,37;22,41;22,45;22,49;22,53;22,57;22,70;22,74;22,78;22,82;22,86;22,94;22,98;22,102;22,106;22,111;26,-108;26,-104;26,-100;26,-11;26,-7;26,-3;26,1;26,5;26,10;26,14;26,18;26,22;26,26;26,31;26,39;26,43;26,48;26,56;26,60;26,64;26,69;26,73;26,77;26,81;26,85;26,90;26,94;26,98;26,102;26,107;26,111;26,115;26,119;29,-115;29,-110;29,-106;29,-101;29,-97;29,-10;29,-6;29,-1;29,3;29,8;29,12;29,16;29,21;29,25;29,29;29,34;29,38;29,42;29,47;29,51;29,56;29,60;29,64;29,69;29,73;29,77;29,82;29,86;29,90;29,95;29,99;29,104;29,108;29,112;29,117;29,121;33,-116;33,-112;33,-107;33,-103;33,-98;33,-94;33,-89;33,-85;33,-80;33,-7;33,-3;33,2;33,6;33,11;33,38;33,43;33,47;33,52;33,56;33,61;33,65;33,70;33,74;33,79;33,83;33,88;33,92;33,97;33,102;33,106;33,111;33,115;33,120;37,-118;37,-113;37,-109;37,-104;37,-99;37,-94;37,-90;37,-85;37,-80;37,-9;37,-4;37,15;37,29;37,34;37,39;37,44;37,48;37,53;37,58;37,63;37,67;37,72;37,77;37,82;37,86;37,91;37,96;37,101;37,105;37,110;37,115;37,120;37,129;37,139;41,-120;41,-115;41,-110;41,-105;41,-100;41,-95;41,-90;41,-85;41,-80;41,-75;41,-4;41,1;41,16;41,21;41,31;41,36;41,41;41,46;41,51;41,56;41,61;41,66;41,71;41,76;41,81;41,86;41,91;41,96;41,101;41,106;41,111;41,116;41,121;41,126;41,141;45,-121;45,-116;45,-111;45,-105;45,-100;45,-95;45,-89;45,-84;45,-79;45,-73;45,-68;45,1;45,7;45,12;45,17;45,23;45,28;45,33;45,39;45,44;45,49;45,55;45,60;45,65;45,71;45,76;45,82;45,87;45,92;45,98;45,103;45,108;45,114;45,119;45,124;45,130;45,135;48,-117;48,-111;48,-106;48,-100;48,-94;48,-88;48,-83;48,-77;48,-71;48,-66;48,-54;48,-3;48,3;48,9;48,15;48,20;48,26;48,32;48,37;48,43;48,49;48,55;48,60;48,66;48,72;48,78;48,83;48,89;48,95;48,100;48,106;48,112;48,118;48,123;48,129;48,135;52,-124;52,-118;52,-112;52,-106;52,-99;52,-93;52,-87;52,-75;52,-68;52,-62;52,-56;52,0;52,6;52,12;52,18;52,25;52,31;52,37;52,43;52,49;52,56;52,62;52,68;52,74;52,80;52,87;52,93;52,99;52,105;52,111;52,118;52,124;52,130;52,136;52,142;56,-160;56,-126;56,-119;56,-112;56,-105;56,-98;56,-92;56,-71;56,-64;56,-3;56,24;56,31;56,37;56,44;56,51;56,58;56,65;56,71;56,78;56,85;56,92;56,99;56,105;56,112;56,119;56,126;56,133;56,160;60,-157;60,-150;60,-135;60,-127;60,-120;60,-112;60,-104;60,-97;60,-74;60,9;60,16;60,32;60,39;60,47;60,54;60,62;60,69;60,77;60,84;60,92;60,100;60,107;60,115;60,122;60,130;60,137;60,145;60,152;64,-171;64,-154;64,-146;64,-137;64,-129;64,-120;64,-112;64,-103;64,-95;64,-69;64,-43;64,17;64,25;64,34;64,42;64,51;64,59;64,68;64,76;64,85;64,93;64,102;64,111;64,119;64,128;64,136;64,145;64,153;64,162;64,170;67,-180;67,-160;67,-150;67,-140;67,-131;67,-121;67,-111;67,-101;67,-91;67,-71;67,-51;67,-42;67,18;67,28;67,38;67,57;67,67;67,77;67,87;67,97;67,107;67,117;67,127;67,136;67,146;67,156;67,166;67,176;71,-180;71,-156;71,-109;71,-86;71,-74;71,-50;71,-39;71,-27;71,56;71,68;71,79;71,91;71,103;71,115;71,127;71,138;71,150;75,-107;75,-92;75,-48;75,-33;75,99;75,143';
  function V(lat,lng){var la=lat*Math.PI/180,lo=lng*Math.PI/180,cl=Math.cos(la);return [cl*Math.sin(lo),Math.sin(la),cl*Math.cos(lo)];}
  var pts=LAND.split(';').map(function(x){var a=x.split(',');return V(+a[0],+a[1]);});
  var UT=V(40.76,-111.89);
  var DEST=[V(35.7,139.7),V(51.5,-0.1),V(-33.9,151.2),V(-23.6,-46.6),V(48.9,2.3)];
  function arcPts(a,b){var d=Math.acos(Math.max(-1,Math.min(1,a[0]*b[0]+a[1]*b[1]+a[2]*b[2]))),sd=Math.sin(d),out=[];
    for(var i=0;i<=28;i++){var t=i/28,A=Math.sin((1-t)*d)/sd,B=Math.sin(t*d)/sd;
      var x=A*a[0]+B*b[0],y=A*a[1]+B*b[1],z=A*a[2]+B*b[2],l=Math.sqrt(x*x+y*y+z*z),lift=1+.22*Math.sin(Math.PI*t);
      out.push([x/l*lift,y/l*lift,z/l*lift]);}
    return out;}
  var ARCS=DEST.map(function(d){return arcPts(UT,d);});
  var W=0,H=0,dpr=1;
  function rs(){var r=cv.getBoundingClientRect();dpr=Math.min(devicePixelRatio||1,2);
    var w=Math.max(1,r.width*dpr|0),h=Math.max(1,r.height*dpr|0);
    if(cv.width!==w||cv.height!==h){cv.width=w;cv.height=h;}W=w;H=h;}
  if('ResizeObserver' in window) new ResizeObserver(rs).observe(cv); rs();
  var FG='#ece7dc';
  function draw(tms){
    if(!W||!H) rs();
    var t=tms*.001, rot=reduce?-.6:t*.26;
    var cx=W/2, cy=H*.52, R=Math.min(W,H)*.44;
    ctx.clearRect(0,0,W,H);
    var cr=Math.cos(rot), sr=Math.sin(rot);
    function P(v){var x=v[0]*cr+v[2]*sr, z=-v[0]*sr+v[2]*cr;return [cx+x*R, cy-v[1]*R, z];}
    // sphere fill + hand-wobble outline
    ctx.beginPath();
    for(var i=0;i<=44;i++){var a=i/44*Math.PI*2,wob=1+.009*Math.sin(a*3+t*.8)+.006*Math.sin(a*5-t*.6);
      var x=cx+Math.cos(a)*R*wob,y=cy+Math.sin(a)*R*wob;i?ctx.lineTo(x,y):ctx.moveTo(x,y);}
    ctx.closePath();
    ctx.fillStyle='rgba(14,14,13,.86)';ctx.fill();
    ctx.strokeStyle='rgba(236,231,220,.85)';ctx.lineWidth=2*dpr;ctx.stroke();
    // land dots
    for(i=0;i<pts.length;i++){var p=P(pts[i]);if(p[2]<=.02)continue;
      var s=(.95+p[2]*1.5)*dpr;
      ctx.globalAlpha=.35+p[2]*.6;ctx.fillStyle=FG;
      ctx.fillRect(p[0]-s/2,p[1]-s/2,s,s);}
    ctx.globalAlpha=1;
    // arcs from UT, staggered loop
    for(i=0;i<ARCS.length;i++){
      var ph=((t*.22)+i*.23)%1, drawTo, alpha;
      if(ph<.42){drawTo=ph/.42;alpha=1;}
      else if(ph<.72){drawTo=1;alpha=1;}
      else if(ph<.9){drawTo=1;alpha=1-(ph-.72)/.18;}
      else continue;
      var arc=ARCS[i], n=Math.max(2,Math.round(arc.length*drawTo)), started=false;
      ctx.beginPath();
      for(var k=0;k<n;k++){var q=P(arc[k]);
        if(q[2]>-.12){ if(!started){ctx.moveTo(q[0],q[1]);started=true;} else ctx.lineTo(q[0],q[1]); }
        else started=false;}
      ctx.strokeStyle='rgba(236,231,220,'+(.9*alpha)+')';ctx.lineWidth=1.6*dpr;ctx.stroke();
      if(drawTo===1){var e=P(arc[arc.length-1]);if(e[2]>0){
        ctx.beginPath();ctx.arc(e[0],e[1],(2.4+1.5*(.5+.5*Math.sin(t*6+i*2)))*dpr,0,7);
        ctx.fillStyle='rgba(236,231,220,'+(.9*alpha)+')';ctx.fill();}}
    }
    // UT pin
    var u=P(UT);
    if(u[2]>-.05){
      var pa=Math.max(0,Math.min(1,(u[2]+.05)/.4));
      ctx.globalAlpha=pa;
      ctx.beginPath();ctx.arc(u[0],u[1],2.6*dpr,0,7);ctx.fillStyle=FG;ctx.fill();
      ctx.beginPath();ctx.moveTo(u[0],u[1]);ctx.lineTo(u[0],u[1]-13*dpr);ctx.strokeStyle=FG;ctx.lineWidth=2*dpr;ctx.stroke();
      ctx.beginPath();ctx.arc(u[0],u[1]-18*dpr,5.6*dpr,0,7);ctx.fillStyle=FG;ctx.fill();
      ctx.beginPath();ctx.arc(u[0],u[1]-18*dpr,2.2*dpr,0,7);ctx.fillStyle='#121110';ctx.fill();
      ctx.globalAlpha=1;
    }
  }
  var raf=0, inView=false, slide=cv.closest('.wslide');
  function loop(tm){ if(!slide||slide.classList.contains('is-on')||slide.classList.contains('is-peek')) draw(tm); raf=requestAnimationFrame(loop); }
  function start(){ if(!raf&&inView&&!reduce) raf=requestAnimationFrame(loop); }
  function stop(){ if(raf){cancelAnimationFrame(raf);raf=0;} }
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(e){ inView=e[0].isIntersecting;
      if(inView){ if(reduce){ rs(); draw(3000); } else start(); } else stop(); },{threshold:0}).observe(cv);
  } else { inView=true; }
  if(reduce){ rs(); draw(3000); } else start();
})();

/* ---------- what you get: animated showcase (chrome-tabs + autoplay + arrows + finger-follow swipe) ---------- */
(function(){
  var root=document.getElementById('jc-wshow'); if(!root) return;
  var frame=root.querySelector('.wshow__frame');
  var slides=[].slice.call(root.querySelectorAll('.wslide')); var n=slides.length; if(!n) return;
  var tabs=[].slice.call(root.querySelectorAll('.wtab'));
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var i=0, timer=0, inView=false, hinted=false;
  var DUR=[4500,4500,4500,4500];                       // per-slide hold (ms)

  function sync(){ tabs.forEach(function(t,j){ t.classList.toggle('on',j===i); t.setAttribute('aria-selected',j===i?'true':'false'); }); }
  function noprog(){ tabs.forEach(function(t){ t.classList.remove('run'); }); }
  function prog(ms){ if(reduce) return; var t=tabs[i]; if(!t) return; noprog();
    t.style.setProperty('--hold',ms+'ms'); void t.offsetWidth; t.classList.add('run'); }
  function place(s,x){ s.style.transition='none'; s.style.setProperty('--offx',x+'px'); void s.offsetWidth; s.style.transition=''; }

  function show(k,replay,dir){
    var prev=i, ni=((k%n)+n)%n;
    if(dir===undefined){ dir=(ni===(prev+1)%n)?1:(ni===(prev-1+n)%n)?-1:(ni>prev?1:-1); }
    i=ni;
    slides.forEach(function(s,j){
      s.classList.remove('is-peek'); s.style.transform='';
      if(j===i) return;
      if(s.classList.contains('is-on')){ s.style.setProperty('--offx',(dir>0?-44:44)+'px'); s.classList.remove('is-on'); }
    });
    var s=slides[i];
    if(s.classList.contains('is-on')){
      if(replay){ s.classList.remove('is-on'); place(s,dir>0?44:-44); s.classList.add('is-on'); }
    } else {
      place(s,dir>0?44:-44); s.classList.add('is-on');
    }
    sync();
  }
  function arm(ms){ clearTimeout(timer); noprog(); if(!inView||reduce) return; prog(ms);
    timer=setTimeout(function(){ show(i+1,true,1); arm(DUR[i]||4500); }, ms); }
  function dismissHint(){ hinted=true; root.classList.remove('hinting'); }
  function manual(k,dir){ dismissHint(); show(k,true,dir); arm(11000); }   // pause autoplay ~11s after manual nav

  [].slice.call(root.querySelectorAll('.wshow__arr')).forEach(function(b){
    b.addEventListener('click',function(){ var d=parseInt(b.getAttribute('data-dir'),10)||1; manual(i+d,d); });
  });
  tabs.forEach(function(t,j){ t.addEventListener('click',function(){ if(j!==i) manual(j, j>i?1:-1); }); });

  // finger-follow swipe (touch): current slide tracks the finger, neighbor peeks in
  var sx=0,sy=0,drag=0,dxl=0,W=1,nb=null,settleT=0,settleFn=null;
  function settle(){ if(settleT){ clearTimeout(settleT); settleT=0; } if(settleFn){ var f=settleFn; settleFn=null; f(); } }
  root.addEventListener('touchstart',function(e){ settle(); var t=e.touches[0]; sx=t.clientX; sy=t.clientY; drag=0; dxl=0; nb=null; W=(frame&&frame.offsetWidth)||1; },{passive:true});
  root.addEventListener('touchmove',function(e){
    if(drag<0) return;
    var t=e.touches[0], dx=t.clientX-sx, dy=t.clientY-sy;
    if(!drag){
      if(Math.abs(dx)>10&&Math.abs(dx)>Math.abs(dy)*1.2){ drag=1; clearTimeout(timer); noprog(); dismissHint(); }
      else if(Math.abs(dy)>10){ drag=-1; return; }
      else return;
    }
    dxl=dx;
    var cur=slides[i];
    cur.style.transition='none'; cur.style.transform='translateX('+dx+'px)';
    var k=(i+(dx<0?1:n-1))%n, cand=slides[k];
    if(nb&&nb!==cand){ nb.classList.remove('is-peek'); nb.style.transform=''; nb.style.transition=''; }
    nb=cand; nb.classList.add('is-peek'); nb.style.transition='none';
    nb.style.transform='translateX('+(dx<0?W+dx:dx-W)+'px)';
  },{passive:true});
  root.addEventListener('touchend',function(){
    if(drag!==1){ drag=0; return; }
    drag=0;
    var dx=dxl, cur=slides[i];
    var commit=nb&&Math.abs(dx)>Math.max(50,W*.22);
    cur.style.transition='transform .32s ease'; if(nb) nb.style.transition='transform .32s ease';
    if(commit){
      var dir=dx<0?1:-1, k=(i+(dir>0?1:n-1))%n, land=nb;
      cur.style.transform='translateX('+(dir>0?-W:W)+'px)';
      land.style.transform='translateX(0px)';
      settleFn=function(){
        slides.forEach(function(s){ if(s===land) return;
          s.style.transition='none'; s.classList.remove('is-on'); s.classList.remove('is-peek'); s.style.transform=''; void s.offsetWidth; s.style.transition=''; });
        land.style.transition='none'; land.style.setProperty('--offx','0px'); land.classList.add('is-on'); land.style.transform=''; void land.offsetWidth; land.style.transition='';
        i=k; sync(); arm(11000);
      };
      settleT=setTimeout(settle,330);
    } else {
      cur.style.transform='translateX(0px)';
      if(nb){ (function(out,side){ out.style.transform='translateX('+side+'px)';
        setTimeout(function(){ out.classList.remove('is-peek'); out.style.transform=''; out.style.transition=''; },340); })(nb,dx<0?W:-W); }
      setTimeout(function(){ cur.style.transform=''; cur.style.transition=''; },340);
      arm(DUR[i]||4500);
    }
    nb=null;
  },{passive:true});

  new IntersectionObserver(function(e){
    var was=inView; inView=e[0].isIntersecting;
    if(inView&&!was){ arm(DUR[i]||4500);           // resume where we left off - no hard replay
      if(!hinted&&!reduce){ setTimeout(function(){ if(inView&&!hinted) root.classList.add('hinting'); },1200); } }
    else if(!inView){ clearTimeout(timer); noprog(); }
  },{threshold:0.35}).observe(root);
  document.addEventListener('visibilitychange',function(){
    if(document.hidden){ clearTimeout(timer); noprog(); }   // freeze the deck while the tab is away
    else if(inView){ arm(DUR[i]||4500); }
  });
})();

/* ---------- join: one-per-cart then checkout ---------- */
(function(){
  function xhr(m,u,b,ok,err){var x=new XMLHttpRequest();x.open(m,u);if(b!=null)x.setRequestHeader('Content-Type','application/json');x.onload=function(){if(x.status>=200&&x.status<300){var d=null;try{d=JSON.parse(x.responseText)}catch(e){}ok(d)}else{err&&err()}};x.onerror=function(){err&&err()};x.send(b!=null?JSON.stringify(b):null)}
  document.querySelectorAll('form.join').forEach(function(f){
    f.addEventListener('submit',function(e){var idi=f.querySelector('[name="id"]');if(!idi)return;e.preventDefault();
      var vid=idi.value,spe=f.querySelector('[name="selling_plan"]'),sp=(spe&&spe.value)||f.getAttribute('data-plan')||'';if(spe&&!spe.value&&sp)spe.value=sp;var btn=f.querySelector('button');if(btn){btn.disabled=true;btn.style.opacity='0.7'}
      function co(){location.href='/checkout'}function fb(){f.submit()}
      xhr('GET','/cart.js',null,function(cart){var line=null;(cart&&cart.items||[]).forEach(function(it){if(String(it.id)===String(vid))line=it});
        if(line){if(line.quantity!==1)xhr('POST','/cart/change.js',{id:line.key,quantity:1},co,co);else co();}
        else{var item={id:vid,quantity:1};if(sp)item.selling_plan=sp;xhr('POST','/cart/add.js',{items:[item]},co,fb);}},fb);
    });
  });
})();
/* ---------- "Join the waitlist" button -> smooth-scroll to waitlist ---------- */
(function(){
  document.querySelectorAll('[data-scroll="wl"]').forEach(function(a){
    a.addEventListener('click',function(e){ e.preventDefault(); var t=document.getElementById('waitlist')||document.getElementById('wl-form'); if(t) t.scrollIntoView({behavior:'smooth',block:'start'}); });
  });
})();
/* ---------- waitlist popup (open / close) ---------- */
(function(){
  var root=document.querySelector('[data-jxwl-root]'); if(!root) return;
  if(root.parentNode!==document.body) document.body.appendChild(root);
  var mod=root.querySelector('.jxwl'); if(!mod) return;
  var opener=null, t=null;
  function open(btn){
    opener=btn||null; if(t){clearTimeout(t);t=null;}
    mod.hidden=false;
    requestAnimationFrame(function(){
      mod.classList.add('is-on');
      var f=mod.querySelector('input[type="email"]');
      if(f){ try{ f.focus({preventScroll:true}); }catch(e){ f.focus(); } }
    });
  }
  function close(){
    mod.classList.remove('is-on');
    t=setTimeout(function(){ mod.hidden=true; },220);
    if(opener&&opener.focus) opener.focus();
  }
  document.addEventListener('click',function(e){
    var o=e.target.closest('[data-jxwl-open]');
    if(o){ e.preventDefault(); open(o); return; }
    if(e.target.closest('[data-jxwl-close]')){ e.preventDefault(); close(); }
  });
  document.addEventListener('keydown',function(e){
    if((e.key==='Escape'||e.keyCode===27)&&!mod.hidden) close();
  });
})();
/* ---------- waitlist -> Klaviyo list (popup + inline form) ---------- */
(function(){
  var REV='2024-10-15';
  function e164(v){var d=(v||'').replace(/[^\d+]/g,'');if(!d)return '';if(d.charAt(0)==='+')return d;if(d.length===10)return '+1'+d;if(d.length===11&&d.charAt(0)==='1')return '+'+d;return '+'+d;}
  function msgBox(form){
    var scope=form.parentNode||document, m=scope.querySelector('.wl-msg');
    return m||document.querySelector('.wl-msg');
  }
  function wire(form){
    if(!form||form.jxWired) return; form.jxWired=1;
    var list=form.getAttribute('data-kl-list')||'';
    var key=form.getAttribute('data-kl-key')||'RjZBeW';
    var ok=form.getAttribute('data-ok')||"You're on the list.";
    var sms=form.getAttribute('data-kl-sms')||'';
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var ei=form.querySelector('input[type="email"]'), pi=form.querySelector('input[type="tel"]');
      var email=((ei&&ei.value)||'').trim(), phone=e164((pi&&pi.value)||'');
      var msg=msgBox(form), btn=form.querySelector('button[type="submit"]');
      function say(txt,bad){ if(!msg)return; msg.style.color=bad?'#d8a13a':''; msg.textContent=txt; }
      function busy(on){ if(!btn)return; btn.disabled=!!on; btn.style.opacity=on?'0.7':''; }
      if(!email||email.indexOf('@')<1){ say('Enter a valid email address.',true); if(ei)ei.focus(); return; }
      say('Adding you...');
      if(!list){ say(ok); form.reset(); return; }
      if(pi&&pi.value.trim()&&!/^\+\d{10,15}$/.test(phone)){ say('Check your phone number, or leave it blank.',true); pi.focus(); return; }
      busy(1);
      var attrs={email:email}; if(phone) attrs.phone_number=phone;
      function sub(id,a){ return fetch('https://a.klaviyo.com/client/subscriptions?company_id='+encodeURIComponent(key),{
        method:'POST',headers:{'Content-Type':'application/json','revision':REV},
        body:JSON.stringify({data:{type:'subscription',attributes:{profile:{data:{type:'profile',attributes:a}}},relationships:{list:{data:{type:'list',id:id}}}}})}); }
      // SMS opt-in on the dedicated SMS list: best effort, never blocks the email signup.
      if(phone&&sms){ sub(sms,{email:email,phone_number:phone}).catch(function(){}); }
      sub(list,attrs).then(function(r){
        busy(0);
        if(r.status===202||r.ok){ say(ok+(phone&&sms?' Check your phone to confirm texts.':'')); form.reset(); if(form.closest('.jxwl')) form.classList.add('is-done'); }
        else { say('Something went wrong. Try again.',true); }
      }).catch(function(){ busy(0); say('Something went wrong. Try again.',true); });
    });
  }
  ['jc-wlmodal-form','wl-form'].forEach(function(id){ wire(document.getElementById(id)); });
})();
